import { ReactElement } from "react";
import { Flex, Text } from "@mantine/core";
import { ICreatePurchaseAddOn } from "@stores/purchases/types";
import { useAddOnContext } from "../../hooks";

/**
 * One add-on's row in the plan estimate. Takes the add-on being priced because
 * it may be an upsert that is not subscribed yet; term, deployment and
 * catalogue row come from the context like everywhere else.
 */
export function AddOnEstimateRow({
  addOn: { product_type, prepaid_units },
}: {
  addOn: ICreatePurchaseAddOn;
}): ReactElement {
  const { title, getEstimateRowItem } = useAddOnContext(product_type);
  const { detail, price } = getEstimateRowItem(prepaid_units) ?? {};

  return (
    <Flex
      data-testid={`plan-estimate_add-on_${product_type}`}
      align="center"
      direction="row"
      gap="xl"
      justify="space-between"
      wrap="nowrap"
      w="100%"
    >
      <Text fz="xs">
        {title}
        {detail && ` (${detail})`}
      </Text>
      {price != null && <Text fz="xs">{price}</Text>}
    </Flex>
  );
}
